import { Component, Input, OnInit } from '@angular/core';
import { timer, zip } from 'rxjs';
import { ConvertedPhoneNumber } from '../../components/phone-input/phone-input.component';
import { GeneralService } from './../../../services/general/general.service';
import { ModalService } from './../../../services/modal/modal.service';
import { SnackbarService } from './../../../services/snackbar/snackbar.service';
import { UserService } from './../../../services/user/user.service';

@Component({
  selector: 'modal-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
})
export class PhoneInputModalComponent implements OnInit {

  @Input() phoneNumber = '';
  @Input() message = '연락처를 통해 친구를 찾으려면 먼저 나의 연락처를 입력해야해요.';
  result: ConvertedPhoneNumber | undefined;

  constructor(
    private snackbarService: SnackbarService, 
    private modalService: ModalService, 
    private userService: UserService,
    private generalService: GeneralService
  ) { }

  ngOnInit() {}

  onChangeResult(result: ConvertedPhoneNumber): void {
    this.result = result;
  }

  onClickNext(): void {
    if (!this.result?.isValid) {
      this.snackbarService.openSnackBar(SnackbarService.WRONG_INPUT_PHONE);
    }
    this.generalService.toggleGlobalPageLoading(true);
    if (this.result !== undefined) {
      const updateObservable = this.userService.updatePhoneNumber(this.result);
      if (updateObservable !== undefined) {
        zip(timer(1000), updateObservable).subscribe((res) => {
          this.generalService.toggleGlobalPageLoading(false);
          this.modalService.dismiss({
            result: true
          });
        }, error => {
          console.error(error);
          this.snackbarService.openSnackBar(SnackbarService.ERROR);
        });
      }
    }
  }
}
